import dynamic from 'next/dynamic';

import Link from 'molecules/Link';
import Section from 'molecules/Section';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';
import type { LayoutProps } from 'types/global';

const RenderBuilderContentLanding = dynamic(
  () => import('utils/builder/RenderBuilderContent').then(mod => ({ default: mod.RenderBuilderContentLanding })),
  { ssr: false },
);

const CookiesButton = dynamic(() => import('layout/footer/components/CookiesButton'), { ssr: false });

const MODEL = 'footers-landing';

const FooterLanding: FC<FooterLandingProps> = ({ legal }) => (
  <footer className="footer-gradient-background py-12 sm:py-16 lg:py-20">
    <Section noBackground paddingBottom="none" paddingTop="none">
      <div className="flex w-full flex-col gap-8 md:flex-row md:justify-between">
        <div className="font-roboto text-sm text-white max-sm:text-center" aria-label="Footer copyright">
          © {new Date().getFullYear()} Prismatic. All rights reserved.
        </div>
        <div className="flex gap-6 max-md:w-full max-md:justify-between max-md:gap-3">
          {hasArrayValues(legal) &&
            legal.map(item => {
              if (!item || !item.label) {
                return null;
              }

              if (item.label === 'Cookie Settings') {
                return <CookiesButton key={item.link} />;
              }

              return (
                <Link
                  key={item.link}
                  href={item.link}
                  className="w-fit px-0.5 font-roboto text-sm text-white hover:text-primary-100"
                  aria-label="Footer link"
                  enablePreview={false}
                >
                  {item.label}
                </Link>
              );
            })}
        </div>
      </div>
    </Section>
  </footer>
);

/**
 * Renders a footer component using content from the Builder.io platform.
 */
export const FooterLandingWithBuilder = ({ content, preview }: LayoutProps) => {
  if (!content) {
    return <RenderBuilderContentLanding model={MODEL} />;
  }

  return preview ? (
    <RenderBuilderContentLanding model={MODEL} content={content} />
  ) : (
    <FooterLanding {...content?.data} />
  );
};

export default FooterLanding;
